import React from 'react';
import { useLocale } from '../../../contexts/LocaleContext.jsx';

/**
 * The MOST RECENT tip and TOP DONOR rows pinned in the stream page chat
 * (mockup 01, ENG-667). Both come from the stream page bootstrap and its
 * `stream_highlights_update` frames, which carry the tipper's chosen name,
 * the amount and the song tipped on — never the tip message (ENG-586).
 */
const ChatHighlights = ({ highlights }) => {
  const { t, format } = useLocale();
  const tip = highlights?.mostRecentTip ?? null;
  const donor = highlights?.topDonor ?? null;
  if (!tip && !donor) return null;

  const nameOf = (name) => (name && String(name).trim()) || t('stream.highlights.anonymous');
  const usd = (amount) => format.usd(amount, { cents: 'auto' });

  return (
    <div className="chat-highlights" data-testid="chat-highlights">
      {tip && (
        <div className="chat-highlight chat-highlight--recent" data-testid="chat-highlight-recent">
          <span className="chat-highlight-tag">{t('stream.highlights.mostRecent')}</span>
          <span className="chat-highlight-text">
            {tip.songTitle
              ? t('stream.highlights.tippedOnSong', { name: nameOf(tip.name), amount: usd(tip.amount), song: tip.songTitle })
              : t('stream.highlights.tipped', { name: nameOf(tip.name), amount: usd(tip.amount) })}
          </span>
        </div>
      )}
      {donor && (
        <div className="chat-highlight chat-highlight--donor" data-testid="chat-highlight-donor">
          <span className="chat-highlight-tag">{t('stream.highlights.topDonor')}</span>
          <span className="chat-highlight-text">
            {t('stream.highlights.donorTotal', { name: nameOf(donor.name), amount: usd(donor.total) })}
          </span>
        </div>
      )}
    </div>
  );
};

export default ChatHighlights;
